// Utility helpers for logo navigation links.
// Default to the marketplace home via an internal SPA route. `LinkedLogo`
// renders `<NamedLink name="LandingPage">` whenever `linkToExternalSite.href`
// is falsy, which is what we want — clicking the logo stays in the same
// tab and uses React Router instead of a full page load. The hosted
// `topbar.logoLink` config can still override this with an external URL.

const DEFAULT_LOGO_LINK = Object.freeze({});

export const resolveLogoLink = logoLinkConfig => {
  const href = logoLinkConfig?.href;
  if (typeof href === 'string' && href.trim().length > 0) {
    return logoLinkConfig;
  }
  return DEFAULT_LOGO_LINK;
};

export default DEFAULT_LOGO_LINK;
